import { Component } from '@angular/core';
import { BaseConfirmPasswordFormComponent } from '@app/components/_shared/account/base-confirm-password-form/base-confirm-password-form.component';

@Component({
  selector: 'app-right-of-access',
  templateUrl: './right-of-access.component.html',
  styleUrls: ['./right-of-access.component.scss']
})
export class RightOfAccessComponent extends BaseConfirmPasswordFormComponent {
  static route = 'account/right-of-access';

  locale: any = {};

  // BaseManagePasswordComponent template variables to be passed
  templateSettings: any = {};

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('RightOfAccessComponent');

    this.templateSettings = {
      header: this.locale.header,
      formParagraph: this.locale.formParagraph,
      submit: this.locale.submit
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/right-of-access/right-of-access.component.ts